<template>
  <div>
    <TopHeader />
    <pet-card v-if="isLoggedIn" />
    <div class="fl-sym-px-4">
      <div v-if="summary" class="fl-sym-mt-5 fl-sym-max-w-sm fl-sym-rounded fl-sym-overflow-hidden fl-sym-mx-auto splash splash-bg" >
        <div
          id="card-header"
          class="fl-sym-px-6 fl-sym-py-4"
          :class="
            summary.triage_level === 1
              ? 'fl-sym-card-header-low'
              : summary.triage_level === 2
              ? 'fl-sym-card-header-high'
              : summary.triage_level === 3
              ? 'fl-sym-card-header-urgent'
              : 'fl-sym-card-header-emergency'
          "
        >
          <div class="fl-sym-font-bold fl-sym-text-white my-title fl-sym-text-lg" >Summary of Symptoms</div>
          <div class="fl-sym-font-bold fl-sym-text-white fl-sym-mb-3 fl-sym-text-3xl fl-sym-font-bold main-symptom">{{summary.summary[0]}}</div>
          <p class="fl-sym-text-gray-700 fl-sym-text-xs fym-p" >Double-check to ensure the correct information about your pet’s symptoms has been collected.</p>
          <p class="fl-sym-text-white fl-sym-font-bold fl-sym-text-xs fym-p" >To change an answer, tap on the answer to return to the question.</p>
        </div>
      </div>
      <div class="fl-sym-max-w-sm fl-sym-mx-auto">
        <div class="fl-sym-card-body fl-sym-rounded fl-sym-shadow-xl fl-sym-bg-white fl-sym-pb-20 fl-sym-card-bottom" >
          <div class="fl-sym-m-4 fl-sym-flex fl-sym-flex-wrap symptoms">
            <button class="fl-sym-text-center fl-sym-border-2 fl-sym-border-intermediate fl-sym-text-black fl-sym-px-2 fl-sym-rounded-full fl-sym-p-1 fl-sym-mb-2 hover:fl-sym-border-primary fl-sym-mr-1 pre-summary-symptoms" v-for="symptom in summary.summary" :key="symptom">{{symptom}}</button>
          </div>
        </div>
      </div>
    </div>
    <div class="fl-sym-mt-3">
      <button
        type="submit"
        class="fl-sym-w-full fl-sym-border-2 fl-sym-border-intermediate fl-sym-text-primary fl-sym-text-sm fl-sym-rounded-full fl-sym-p-4 fl-sym-font-semibold fl-sym-mb-3 hover:fl-sym-border-primary "
      >
        <router-link
          class="fl-sym-text-primary fl-btn-text fl-sym-font-bold"
          :to="{ name: 'symptom-checker-summary' }"
        >
          Yes, this is correct
         <img src="@/assets/chevron-right-thin.svg" width="8" class="chevron-left-thin-button fl-sym-ml-13 fl-sym-float-right fl-sym-text-primary fl-sym-font-bold">

        </router-link>
      </button>
    </div>

    <div class="fl-sym-flex fl-sym-mt-2 fl-sym-justify-center fl-sym-text-sm">
      <div class="fl-sym-text-primary fl-sym-font-bold hover:fl-sym-text-opacity-75">
        <div class="link" @click="onBack">Back</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex"

// components import
import TopHeader from "@/components/headerNav/TopHeader.vue"
import PetCard from "@/components/pet-card"
// import Indicator from '@/components/indicator.vue'
// import Result from "@/components/result";

import back2 from "@/assets/back2.png"
import back1 from "@/assets/back1.png"

export default {
  components: {
    TopHeader,
    PetCard,
    // Indicator
  },
  computed: {
    ...mapState({
      summary: (state) => state.sc.summary,
      isLoggedIn: (state) => state.auth.token !== "",
    }),
  },
  async mounted() {
    await this.$store.dispatch("sc/summary")
    this.headerColor()
  },
  props: {
    priority: {
      default: 1,
      type: Number,
    },
  },
  methods: {
    rotate() {},
    async onBack() {
      await this.$store.dispatch("sc/back")
    },

    headerColor() {
      /*let self = this;
      let header = document.getElementById("card-header");
      if (self.summary.triage_level==1){
        header.classList.add("fl-sym-card-header-low");
      } else if (self.summary.triage_level==2){
        header.classList.add("fl-sym-card-header-high");
      } else if (self.summary.triage_level==3){
        header.classList.add("fl-sym-card-header-urgent");
      } else {
        header.classList.add("fl-sym-card-header-emergency");
      }*/
    },
  },
  data() {
    return {
      back1,
      back2,
    }
  },
}
</script>

<style scoped>
.fl-sym-card-header-emergency {
  background: url("../../assets/felcana-owner-small.svg") center,
    transparent linear-gradient(360deg, #ffa25ce6 0%, #d92818 100%) 0% 0%
      no-repeat padding-box;
  background-blend-mode: color-dodge;
  border-radius: 14px 14px 0px 0px;
}
.fl-sym-card-header-urgent {
  background: url("../../assets/felcana-owner-small.svg") center,
    transparent linear-gradient(360deg, #fab83be6 0%, #ff7f00 100%) 0% 0%
      no-repeat padding-box;
  background-blend-mode: color-dodge;
  border-radius: 14px 14px 0px 0px;
}
.fl-sym-card-header-high {
  background: url("../../assets/felcana-owner-small.svg") center,
    transparent linear-gradient(360deg, #ffd427e6 0%, #ffcc00 100%) 0% 0%
      no-repeat padding-box;
  background-blend-mode: color-dodge;
  border-radius: 14px 14px 0px 0px;
}
.fl-sym-card-header-low {
  background: url("../../assets/felcana-owner-small.svg") center,
    transparent linear-gradient(360deg, #96d90be6 0%, #5baa00 100%) 0% 0%
      no-repeat padding-box;
  background-blend-mode: color-dodge;
  border-radius: 14px 14px 0px 0px;
}

.my-title {
  font: var(--unnamed-font-style-normal) normal
    var(--unnamed-font-weight-normal) var(--unnamed-font-size-12) /
    var(--unnamed-line-spacing-16)
    var(--unnamed-font-family-sfprodisplay-regular);
  letter-spacing: var(--unnamed-character-spacing-0-8);
  text-align: left;
  letter-spacing: 0.8px;
  color: #ffffffcc;
  opacity: 1;
  text-transform: uppercase;
  font-size: 12px;
}

.back-btn {
  color: var(--progress-bar-filler);
  text-align: center;
  letter-spacing: 0.64px;
  color: #00c5e3;
  opacity: 1;
}

.email-password {
  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
  border: 2px solid var(--unnamed-color-707070);
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 2px solid #707070;
  opacity: 1;
}

.fym-btn-text {
  color: var(--progress-bar-filler);
  text-align: center;
  letter-spacing: 0.64px;
  color: #00c5e3;
  opacity: 1;
}

.fym-p {
  letter-spacing: var(--unnamed-character-spacing-0-8);
  color: var(--unnamed-color-ffffff);
  text-align: left;
  letter-spacing: 0.8px;
  color: #ffffff;
  opacity: 1;
}
.fl-sym-text-black {
  color: black !important;
}

.fl-tag {
  letter-spacing: 0;

  text-align: center;
  letter-spacing: 0px;
  color: #6f7878;
  border: 2px solid #999999;

  opacity: 1;
}

.my-heading-header {
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold)
    var(--unnamed-font-size-28) / var(--unnamed-line-spacing-32)
    var(--unnamed-font-family-sf-pro-display);
  letter-spacing: var(--unnamed-character-spacing--0-16);
  color: var(--unnamed-color-ffffff);
  text-align: left;
  font: normal normal bold 28px/32px SF Pro Display;
  letter-spacing: -0.16px;
  color: #ffffff;
  opacity: 1;
}
.fl-sym-card-bottom {
  border-radius: 0 0 14px 14px;
}

.pre-summary-symptoms {
  color: #6F7878;
  font-size: 13px;
  line-height: 18px;
  text-transform: uppercase;
}
.pre-summary-symptoms:hover {
  color: #53D5E6!important;
}
.main-symptom {
  text-transform: lowercase;
}
.main-symptom::first-letter {
  text-transform: uppercase;
}

</style>

